import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { useTransition } from '@/context/TransitionContext'

interface TransitionLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string
  children: ReactNode
}

// Drop-in replacement for React Router's <Link> on cross-route navigations.
// Hash links and same-page links fall through to normal behaviour.
export function TransitionLink({ to, children, onClick, ...props }: TransitionLinkProps) {
  const { transitionTo } = useTransition()
  const location = useLocation()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Let hash-only links (e.g. /#about) work normally
    if (to.includes('#')) {
      onClick?.(e)
      return
    }

    e.preventDefault()
    onClick?.(e)

    // Already on the target page — skip the transition
    if (location.pathname === to) return

    transitionTo(to)
  }

  return (
    <a href={to} onClick={handleClick} {...props}>
      {children}
    </a>
  )
}
